import { useEffect } from 'react';
import App from '../App';
import { PostHogProvider } from 'posthog-js/react';
import { TRACKING_ENABLED, POSTHOG_HOST } from '@services/environment';
import { submitOnboardingStep } from '@services/onboarding-api';
import {
  ONBOARDING_STEP,
  DEFAULT_TOTAL_ONBOARDING_STEPS,
} from '@constants/onboarding';
import type { PostHogConfig } from 'posthog-js';

const options: Partial<PostHogConfig> = {
  api_host: POSTHOG_HOST,
  defaults: '2025-05-24',
};

// Component wrapper that conditionally applies PostHogProvider
export default function AppWithAnalytics() {
  // ad blocker detection & logging
  useEffect(() => {
    if (TRACKING_ENABLED && POSTHOG_HOST) {
      fetch(POSTHOG_HOST, { method: 'HEAD', mode: 'no-cors' }).catch(
        async () =>
          await submitOnboardingStep({
            stepNumber: 1,
            stepName: ONBOARDING_STEP.BIRTHDAY,
            stepData: { adBlockerDetected: true },
            totalSteps: DEFAULT_TOTAL_ONBOARDING_STEPS,
          }).catch(apiError =>
            console.error(
              'Failed to log ad blocker detection to onboarding API:',
              apiError
            )
          )
      );
    }
  }, []); // Empty dependency array - runs only once

  // Skip PostHog provider when tracking is disabled

  if (!TRACKING_ENABLED) {
    return <App />;
  }

  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}
    >
      <App />
    </PostHogProvider>
  );
}
